"use strict";

var React = require("react/addons");

var Header = React.createClass({
  displayName: "Header",

  render: function render() {
    return React.createElement(
      "header",
      { className: "header" },
      React.createElement(
        "h1",
        { className: "header__title" },
        "React Choice"
      )
    );
  }
});

module.exports = Header;


/*****************
 ** WEBPACK FOOTER
 ** ./example/components/header.jsx
 ** module id = 3
 ** module chunks = 0
 **/